// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__6H_89","content":"styles_content__jBlC_","title":"styles_title__6hf0g","text":"styles_text__U5Pwv","arrow":"styles_arrow__8R0H0"};
module.exports.__checksum = "d26a95b0c2b8"
